export enum Sentry {
  EarningsYieldPanel = 'failed to get earnings for product yield panel',
  RatesAndFees = 'Failed to load rate/fee information',
  Affiliate = 'error getting affiliate',
  Transfer = 'Error authorizing transfer',
  ManualBankAccount = 'Error connecting manual bank account',
  Sweep = 'Error sending transfer',
}
